import { CheckRounded, PlayCircle } from '@mui/icons-material';
import { ReactElement, useEffect, useState } from 'react';

// Components.
import { OnboardingVerifyEmailForm } from 'components';
import { Box, Card, CardContent, CardMedia, Grid, Stack } from '@mui/material';
import { ModalVideo } from 'components/ModalVideo';

// Hooks.
import { useLoadEvent } from 'hooks';

// Styles.
import styles from './VerifyEmailPage.module.scss';

export const VerifyEmailPage = (): ReactElement => {
  const fireLoadEvent = useLoadEvent({ PageType: 'Registration Page', RegistrationStep: 1 });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoId, setVideoId] = useState('');

  const createAccountVideoId = '1118760767';

  const createAccountVideoThumbnailUrl =
    'https://i.vimeocdn.com/video/2059485960-c7f31056a99bbf65bacf357ee4e95d70a81f2b3048f272d46327a7705343b03b-d';

  const handleModalOpen = (videoId: string, isOpen: boolean) => {
    setVideoId(videoId);
    setIsModalOpen(isOpen);
  };

  useEffect(() => {
    fireLoadEvent();
  }, [fireLoadEvent]);

  return (
    <>
      <Grid container className={styles.container} spacing={6}>
        <Grid size={{ xs: 12, md: 6 }}>
          <h1>Create an account – and take control of your CME.</h1>

          <Card className={styles.videoCard} variant="outlined">
            <h4>Create Your CME Passport Account</h4>
            <Box className={styles.overlayWrapper}>
              <CardMedia
                className={styles.image}
                component="img"
                image={createAccountVideoThumbnailUrl}
                alt="Create Your CME Passport Account"
              />
              <CardContent className={styles.overlay} onClick={() => handleModalOpen(createAccountVideoId, true)}>
                <PlayCircle className={styles.playIcon} />
              </CardContent>
            </Box>
          </Card>

          <Stack spacing={2} className={styles.checkList}>
            <Box className={styles.checkRow}>
              <CheckRounded className={styles.checkIcon} />
              <span>
                When creating your account, use an email address you can access even if you leave your current
                organization.
              </span>
            </Box>
            <Box className={styles.checkRow}>
              <CheckRounded className={styles.checkIcon} />
              <span>
                CME Passport keeps track of your CME credits for you. You do not upload credits. Instead, CME
                coordinators report credits on your behalf.
              </span>
            </Box>
            <Box className={styles.checkRow}>
              <CheckRounded className={styles.checkIcon} />
              <span>
                When you register for a CME activity, ask the organizer to report your credit to the Accreditation
                Council for Continuing Medical Education (ACCME).
              </span>
            </Box>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <OnboardingVerifyEmailForm />
        </Grid>
      </Grid>

      <ModalVideo isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} videoId={videoId} autoplay muted={false} />
    </>
  );
};
